import { selectCountries } from '@modules/admin/Admin.Dux'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import './MultiSelect.scss'
import SelectField from './SelectField'

class SelectCountryField extends Component {
  static defaultProps = {
    countries: [],
    valueKey: 'code',
  }

  render() {
    const { countries, placeholder, multi, t } = this.props
    return (
      <SelectField
        {...this.props}
        placeholder={placeholder || `${multi ? t('Países') : t('País')}`}
        options={countries}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  countries: selectCountries(state),
})

export default compose(withTranslation(), connect(mapStateToProps))(SelectCountryField)
